import {Component, Input, OnInit} from '@angular/core';
import {OpenpanelAnalyticsService} from "../../services/openpanel-analytics.service";

@Component({
  selector: 'app-exibir-whatsapp',
  templateUrl: './exibir-whatsapp.component.html',
  styleUrls: ['./exibir-whatsapp.component.scss']
})
export class ExibirWhatsappComponent implements OnInit {
  @Input()
  empresa: any;
  @Input()
  light: boolean;

  constructor(private openpanelAnalyticsService: OpenpanelAnalyticsService) { }

  ngOnInit(): void {
  }

  getNumeroZap(){
    if(!this.empresa) return '';

    if(this.empresa.numeroWhatsapp)
      return this.empresa.numeroWhatsapp.whatsapp;

    return this.empresa.whatsapp
  }

  rastreieCliqueWhatsapp() {
    const numero = this.getNumeroZap();

    if (!numero) {
      return;
    }

    this.openpanelAnalyticsService.trackOutgoingLink(`http://wa.me/55${numero}`, 'exibir_whatsapp', {
      empresaId: this.empresa?.id
    });
  }
}
